import { render, staticRenderFns } from "./SocialField.vue?vue&type=template&id=0f97faad&"
import script from "./SocialField.vue?vue&type=script&lang=js&"
export * from "./SocialField.vue?vue&type=script&lang=js&"
import style0 from "./SocialField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports